<template>
  <progress-bar @input="dispatch"
      @simulate="dispatch"
      @ghost="dispatch"
      progressColor="#666"
      thumbColor="#d1d1d1"
      :time="playtime"
      :duration="duration"
      :highlightColor="highlightColor"
      :quantiles="quantiles"
      :large="true"
      :hideProgressThumb="true"></progress-bar>
</template>

<script>
import { mapState } from 'redux-vuex';
import color from 'color';

import store from '@/store';
import select from '@/store/selectors';
import { ProgressBar } from '../shared-components';

export default {
  components: {
    ProgressBar,
  },
  data: mapState({
    thumbColor: select.theme.brandLightest,
    progressColor: select.theme.brandDark,
    playtime: select.playtime,
    highlightColor: select.theme.brandLightest,
    duration: select.duration,
    quantiles: select.quantiles,
  }),
  methods: {
    dispatch: store.dispatch,
    color,
  },
};
</script>

<style lang="postcss" scoped>

</style>
